<form>
   <div class="sam-form-row">
      <label>Load-Test Mode: </label>
      <div class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width">
         <kendo-switch
            [checked]="isLoadTestModeEnabled$ | async"
            (valueChange)="toggleLoadTestEnabled($event)"
         ></kendo-switch>
      </div>
   </div>
</form>
